import { useAccountLimitsContext } from "../../../../context/account-limit-context";
import { useLexicalContext } from "../../lexical-context";

/**
 *
 * @returns A boolean which indicates that surveys are enabled for the account and that the
 * editor is not in a toChannel mode.
 */
export function useSurveysEnabledLexical():
  | {
      enabled: false;
    }
  | { enabled: true; type: "channel" | "individual" } {
  const { toChannel } = useLexicalContext();
  const enabled = useSurveysEnabled();
  if (!enabled) return { enabled: false };

  return { enabled: true, type: toChannel ? "channel" : "individual" };
}

export function useSurveysEnabled(): boolean {
  const { listen_entitlement } = useAccountLimitsContext();

  return listen_entitlement === "Pro";
}
